const CONFIG = {
    BASE_URL: 'https://restaurant-api.dicoding.dev',
    BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images',
    CACHE_NAME: 'restaurants-cache',
    DATABASE_NAME: 'pwa-restaurants-database',
    DATABASE_VERSION: 1,
    OBJECT_STORE_NAME: 'restaurants'
};

export default CONFIG;
